<template>
  <div id="app">
    <h1 class="visually-hidden">Welcome to Baron - Your Gateway to Success</h1>

    <!-- navBar -->
    <navbar></navbar>

    <section>
      <router-view :class="{'pageContent': isLoginPage}"></router-view>

    </section>

    <!-- footer -->
    <footersection></footersection>

  </div>
</template>

<script>
import store from "./store/index.js"
import navbar from './components/topNavBar/TopNavBar.vue'
import footersection from './components/footer/Footer.vue'

export default {
  data() {
    return {
      form: "",
      accountType: null,
      isLoginPage: true,
      lang: 'ar'
    };
  },
  watch: {
    '$route' (to, from) {
      this.isLoginPage = true;
      if(this.$route.name == 'login'){
        this.isLoginPage = false;
      }
      else{
        this.isLoginPage = true;
      }
    }
  },
  components: {
    navbar,
    footersection
  },
  created() {
    this.isLoginPage = true;
    if(this.$route.name == 'login' || this.$route.name == 'landingPage'){
      this.isLoginPage = false;
    }
    else{
      this.isLoginPage = true;
    }

    this.lang = 'ar';
    store.commit("SET_LANG", "ar");
    store.commit("SET_INTERNATIONALIZATION", this.lang)
  }
};
</script>
<style scoped lang="scss">

  @font-face {
    font-family: "cairo-bold";
    src: url("../src/assets/fonts/Cairo-Bold.ttf");
  }
  @font-face {
    font-family: "cairo-regular";
    src: url("../src/assets/fonts/Cairo-Regular.ttf");
  }
  body {
    margin: 0;
    padding: 0;
    font-family: "cairo-regular" !important;
    background-color: #d5dae5;
    -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
  }
  .pageContent{
    width: 100%;
    float: left;
    padding-left: 0px;
    padding-right: 0px;
  }
  .btn-primary{
    color: #fff;
    background-color: var(--brand-teal) !important;
    border-color: var(--brand-teal) !important;
  }
</style>
